import React from 'react';
import axios from 'axios';
import { Header } from 'semantic-ui-react';
import NewSP1 from './NewSP1';
import NewSP2 from './NewSP2';
import NewSP3 from './NewSP3';
import NewSP4 from './NewSP4';
import NewSP5 from './NewSP5';
import Semesters from './Semesters';
import SemesterCourses from './SemesterCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class NewStudyProgram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgUnit: '',
            studyProgramBasic: '',
            studyPrograms: [],
            studyProgramsDropdown: [],
            studyCycleId: '',
            languageIds: [],
            organizationalUnitIds: [],
            academicYearStart: '',
            name: '',
            ects: '',
            durationYear: '',
            durationSemester: '',
            title: '',

            description: '',
            enrollmentTerms: '',
            studyRules: '',

            nextCycleEnrollmentPossibility: '',
            professionalStatus: '',
            additionalInformation: '',

            additionalInformationSource: '',
            studyGoals: '',
            studyOutcomes: '',

            details: '',
            gradingScale: '',
            classificationOfQualification: '',

            nameEng: null,
            titleEng: '',

            descriptionEng: '',
            enrollmentTermsEng: '',
            studyRulesEng: '',

            nextCycleEnrollmentPossibilityEng: '',
            professionalStatusEng: '',
            additionalInformationEng: '',

            additionalInformationSourceEng: '',
            studyGoalsEng: '',
            studyOutcomesEng: '',

            detailsEng: '',
            gradingScaleEng: '',
            classificationOfQualificationEng: '',

            newSP: '',

            step: 1,
            create: false,
            success: false,

            otherLangOptions: [],
            otherLang: ''
        };

        this.step2 = this.step2.bind(this);
        this.step3 = this.step3.bind(this);
        this.step4 = this.step4.bind(this);
        this.step5 = this.step5.bind(this);
        this.createSP = this.createSP.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.createSPImpl = this.createSPImpl.bind(this);
        this.resetValues = this.resetValues.bind(this);
    }

    componentDidMount() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.id,
                        value: el.twoLetterCode,
                        text: el.name
                    })),
                    // otherLang: this.state.mob..filter((e) => e.originalLanguage === true)[0].language
                });
            });
    }

    createSPImpl() {
        const {
            studyProgramBasic, academicYearStart, name, ects, durationYear, durationSemester,
            description, enrollmentTerms, studyRules, nextCycleEnrollmentPossibility, professionalStatus,
            additionalInformation, additionalInformationSource, studyGoals, studyOutcomes, details,
            gradingScale, classificationOfQualification, languageIds, studyCycleId, organizationalUnitIds, title,
            nameEng, descriptionEng, enrollmentTermsEng, studyRulesEng, nextCycleEnrollmentPossibilityEng, professionalStatusEng,
            additionalInformationEng, additionalInformationSourceEng, studyGoalsEng, studyOutcomesEng, detailsEng,
            gradingScaleEng, classificationOfQualificationEng, languageIdsEng, studyCycleIdEng, organizationalUnitIdsEng, titleEng
        } = this.state;

        let studyProgram = {};

        if (studyProgramBasic) studyProgram = { ...studyProgram, studyProgramBasic };
        if (academicYearStart) studyProgram = { ...studyProgram, academicYearStart };
        if (name) studyProgram = { ...studyProgram, name };
        if (ects) studyProgram = { ...studyProgram, ects };
        if (durationYear) studyProgram = { ...studyProgram, durationYear };
        if (durationSemester) studyProgram = { ...studyProgram, durationSemester };
        if (title) studyProgram = { ...studyProgram, titleId: title };
        if (description) studyProgram = { ...studyProgram, description, };
        if (enrollmentTerms) studyProgram = { ...studyProgram, enrollmentTerms };
        if (studyRules) studyProgram = { ...studyProgram, studyRules };
        if (nextCycleEnrollmentPossibility) studyProgram = { ...studyProgram, nextCycleEnrollmentPossibility };
        if (professionalStatus) studyProgram = { ...studyProgram, professionalStatus };
        if (additionalInformation) studyProgram = { ...studyProgram, additionalInformation };
        if (additionalInformationSource) studyProgram = { ...studyProgram, additionalInformationSource };
        if (studyGoals) studyProgram = { ...studyProgram, studyGoals };
        if (studyOutcomes) studyProgram = { ...studyProgram, studyOutcomes };
        if (details) studyProgram = { ...studyProgram, details };
        if (gradingScale) studyProgram = { ...studyProgram, gradingScale };
        if (classificationOfQualification) studyProgram = { ...studyProgram, classificationOfQualification };


        if (languageIds) studyProgram = { ...studyProgram, languageIds };
        if (studyCycleId) studyProgram = { ...studyProgram, studyCycleId };
        if (organizationalUnitIds) studyProgram = { ...studyProgram, organizationalUnitIds };

        let translations = [];
        if (nameEng) {
            translations = [...translations,
                {
                    name: nameEng,
                    language: { twoLetterCode: 'en' },
                    description: descriptionEng,
                    enrollmentTerms: enrollmentTermsEng,
                    studyRules: studyRulesEng,
                    nextCycleEnrollmentPossibility: nextCycleEnrollmentPossibilityEng,
                    professionalStatus: professionalStatusEng,
                    additionalInformation: additionalInformationEng,
                    additionalInformationSource: additionalInformationSourceEng,
                    studyGoals: studyGoalsEng,
                    studyOutcomes: studyOutcomesEng,
                    details: detailsEng,
                    gradingScale: gradingScaleEng,
                    classificationOfQualification: classificationOfQualificationEng,
                    studyProgram: null
                }
            ];
        }


        if (translations.length) studyProgram = { ...studyProgram, translations };

        console.log('study', studyProgram);

        axios.post('study-programs/save', { ...studyProgram })
            .then(res => {
                console.log('res.data', res.data);
                const newSP = res.data;
                this.setState({ newSP });
                this.setState({ create: true, success: true, step: 6 });
            })
            .catch(err => {
                console.log('err.response.data', err.response);
                this.resetValues();
                this.setState({ create: true, success: false, step: 1 });
            });
    }

    resetValues() {
        this.setState({
            orgUnit: '',
            studyCycleId: '',
            languageIds: [],
            organizationalUnitIds: [],
            academicYearStart: '',
            name: '',
            ects: '',
            durationYear: '',
            durationSemester: '',
            description: '',
            enrollmentTerms: '',
            studyRules: '',
            nextCycleEnrollmentPossibility: '',
            professionalStatus: '',
            additionalInformation: '',
            title: '',

            additionalInformationSource: '',
            studyGoals: '',
            studyOutcomes: '',

            details: '',
            gradingScale: '',
            classificationOfQualification: '',

            titleEng: '',

            nameEng: null,
            descriptionEng: '',
            enrollmentTermsEng: '',
            studyRulesEng: '',

            nextCycleEnrollmentPossibilityEng: '',
            professionalStatusEng: '',
            additionalInformationEng: '',

            additionalInformationSourceEng: '',
            studyGoalsEng: '',
            studyOutcomesEng: '',

            detailsEng: '',
            gradingScaleEng: '',
            classificationOfQualificationEng: '',
            step: 1
        });
    }

    step2(
        orgUnit, studyProgramBasic, studyCycleId, languageIds, organizationalUnitIds,
        academicYearStart, name, nameEng, ects, durationYear, durationSemester, SPorgUnits, title
    ) {
        this.setState({
            orgUnit,
            studyProgramBasic,
            studyCycleId,
            languageIds,
            organizationalUnitIds,
            academicYearStart,
            name,
            nameEng,
            ects,
            durationYear,
            durationSemester,
            SPorgUnits,
            title,
            step: 2
        });
    }

    step3(description, enrollmentTerms, studyRules, descriptionEng, enrollmentTermsEng, studyRulesEng) {
        this.setState({
            description,
            enrollmentTerms,
            studyRules,
            descriptionEng,
            enrollmentTermsEng,
            studyRulesEng,
            step: 3
        });
    }

    step4(
        nextCycleEnrollmentPossibility, professionalStatus, additionalInformation,
        nextCycleEnrollmentPossibilityEng, professionalStatusEng, additionalInformationEng
    ) {
        this.setState({
            nextCycleEnrollmentPossibility,
            professionalStatus,
            additionalInformation,
            nextCycleEnrollmentPossibilityEng,
            professionalStatusEng,
            additionalInformationEng,
            step: 4
        });
    }

    step5(additionalInformationSource, studyGoals, studyOutcomes, additionalInformationSourceEng, studyGoalsEng, studyOutcomesEng) {
        this.setState({
            additionalInformationSource,
            studyGoals,
            studyOutcomes,
            additionalInformationSourceEng,
            studyGoalsEng,
            studyOutcomesEng,
            step: 5
        });
    }

    createSP(details, gradingScale, classificationOfQualification, detailsEng, gradingScaleEng, classificationOfQualificationEng) {
        this.setState({
            details,
            gradingScale,
            classificationOfQualification,
            detailsEng,
            gradingScaleEng,
            classificationOfQualificationEng
        }, () => { this.createSPImpl(); });
    }


    previousStep(step) {
        this.setState({ step });
    }


    render() {
        const { step } = this.state;
        if (step === 1) {
            return (
                <NewSP1
                    orgUnits={this.props.orgUnits}
                    languages={this.props.languages}
                    titles={this.props.titles}
                    studyCycles={this.props.studyCycles}
                    academicYears={this.props.academicYears}
                    languagesDropdown={this.props.languagesDropdown}
                    studyCyclesDropdown={this.props.studyCyclesDropdown}
                    academicYearsDropdown={this.props.academicYearsDropdown}

                    step2={this.step2}
                    orgUnit={this.state.orgUnit}
                    studyProgramBasic={this.state.studyProgramBasic}
                    studyPrograms={this.state.studyPrograms}
                    studyProgramsDropdown={this.state.studyProgramsDropdown}
                    studyCycleId={this.state.studyCycleId}
                    languageIds={this.state.languageIds}
                    organizationalUnitIds={this.state.organizationalUnitIds}
                    academicYearStart={this.state.academicYearStart}
                    name={this.state.name}
                    nameEng={this.state.nameEng}
                    ects={this.state.ects}
                    durationYear={this.state.durationYear}
                    durationSemester={this.state.durationSemester}
                    SPorgUnits={this.state.SPorgUnits}
                    title={this.state.title}

                    create={this.state.create}
                    success={this.state.success}
                    resetValues={this.resetValues}
                />
            );
        } else if (step === 2) {
            return (
                <NewSP2
                    previousStep={this.previousStep}
                    step3={this.step3}
                    description={this.state.description}
                    enrollmentTerms={this.state.enrollmentTerms}
                    studyRules={this.state.studyRules}
                    descriptionEng={this.state.descriptionEng}
                    enrollmentTermsEng={this.state.enrollmentTermsEng}
                    studyRulesEng={this.state.studyRulesEng}
                />
            );
        } else if (step === 3) {
            return (
                <NewSP3
                    previousStep={this.previousStep}
                    step4={this.step4}
                    nextCycleEnrollmentPossibility={this.state.nextCycleEnrollmentPossibility}
                    professionalStatus={this.state.professionalStatus}
                    additionalInformation={this.state.additionalInformation}
                    nextCycleEnrollmentPossibilityEng={this.state.nextCycleEnrollmentPossibilityEng}
                    professionalStatusEng={this.state.professionalStatusEng}
                    additionalInformationEng={this.state.additionalInformationEng}
                />
            );
        } else if (step === 4) {
            return (
                <NewSP4
                    previousStep={this.previousStep}
                    step5={this.step5}
                    details={this.state.details}
                    gradingScale={this.state.gradingScale}
                    classificationOfQualification={this.state.classificationOfQualification}
                    detailsEng={this.state.detailsEng}
                    gradingScaleEng={this.state.gradingScaleEng}
                    classificationOfQualificationEng={this.state.classificationOfQualificationEng}
                />
            );
        } else if (step === 5) {
            return (
                <NewSP5
                    previousStep={this.previousStep}
                    createSP={this.createSP}
                />
            );
        } else if (step === 6) {
            return (
                <div>
                    <Header as="h1">Kreiranje semestara</Header>
                    <Semesters
                        newSP={this.state.newSP}
                        studyProgramId={this.state.studyProgramBasic}
                        orgUnit={this.state.orgUnit}
                        create={this.state.create}
                        success={this.state.success}
                        firstStep={() => { this.setState({ step: 1 }); this.resetValues(); }}
                        nextStep={(step) => this.setState({ step })}
                    />
                </div>
            );
        } else if (step === 7) {
            return (
                <div>
                    <Header as="h1">Kreiranje semestara</Header>
                    <SemesterCourses
                        newSP={this.state.newSP}
                        orgUnit={this.state.orgUnit}
                        firstStep={() => { this.setState({ step: 1 }); this.resetValues(); }}
                    />
                </div>
            );
        }
        return (
            <div></div>
        );
    }
}

export default NewStudyProgram;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewStudyProgram.js